import React from 'react'

const NotFound = () => {
  return (
    <div style={{ padding: 40 }}>
      <h2>페이지를 찾을 수 없습니다</h2>
      <p>요청하신 경로가 존재하지 않습니다.</p>
      <a href="/admin/confirm">관리자 홈으로 이동</a>
    </div>
  )
}

export default NotFound
